export const REMORTGAGE_PRODUCTS_FETCH = 'CS/REMORTGAGE_PRODUCTS_FETCH';
export const REMORTGAGE_PRODUCTS_FETCH_SUCCESS = `${REMORTGAGE_PRODUCTS_FETCH}_SUCCESS`;
export const REMORTGAGE_PRODUCTS_FETCH_ERROR = `${REMORTGAGE_PRODUCTS_FETCH}_ERROR`;

export const REMORTGAGE_ELIGIBILITY_FETCH = 'CS/REMORTGAGE_ELIGIBILITY_FETCH';
export const REMORTGAGE_ELIGIBILITY_FETCH_SUCCESS = `${REMORTGAGE_ELIGIBILITY_FETCH}_SUCCESS`;
export const REMORTGAGE_ELIGIBILITY_FETCH_ERROR = `${REMORTGAGE_ELIGIBILITY_FETCH}_ERROR`;

export const REMORTGAGE_RESET_STATE = 'CS/REMORTGAGE_RESET_STATE';
